export default __webpack_public_path__ + "static/media/meat.6d061636.svg";